module.exports = __webpack_public_path__ + "img/GabinetePanelAbiertoEnActivacion.740d9301.svg";